import * as React from "react";
import type { SVGProps } from "react";
const SvgIconLivingSpace = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={512}
    height={512}
    data-name="Layer 1"
    {...props}
  >
    <path
      fill="#242323"
      d="M486 284.12v104.7H336.44v61.79H164.23V338.27h-17.34v-10.33h42.58V191.38h10.33v5.3h132.91v10.33H199.8v120.93h12.72v10.33h-37.96v102.01H326.1V280.23h-47.41V269.9h57.75v34.89h42.85v10.33h-42.85v63.36h139.23v-63.36h-43.26v-10.33h43.26v-20.67z"
    />
    <path
      fill="#242323"
      d="M486 196.68v41.54h-10.33v-31.21h-90.94v-10.33h55.17V71.72H199.8v52.45h-10.33v-13.45H51.26v29.53H40.92v-39.86h148.55v-39h260.76v135.29zM120.59 333.31l-19.9 19.91-7.31-7.3 7.29-7.3H40.74v-153.2l-7.43 7.43-7.31-7.31 19.91-19.91 19.91 19.91-7.31 7.31-7.43-7.43v142.86h49.87l-7.57-7.57 7.31-7.31z"
    />
  </svg>
);
export default SvgIconLivingSpace;
